import { Label, Tag, Text } from 'react-konva';

interface DimensionLabelProps {
  x: number;
  y: number;
  width: number;
  height: number;
}

/**
 * Figma-style "W x H" pill shown below the bounding box during resize.
 */
export function DimensionLabel({ x, y, width, height }: DimensionLabelProps) {
  const label = `${Math.round(width)} \u00d7 ${Math.round(height)}`;

  return (
    <Label x={x + width / 2} y={y + height + 12} offsetX={0}>
      <Tag fill="rgba(0,0,0,0.75)" cornerRadius={4} pointerDirection="none" />
      <Text
        text={label}
        fontSize={11}
        fontFamily="Inter"
        fill="#ffffff"
        padding={4}
        align="center"
      />
    </Label>
  );
}
